/* Fish Finder Coach accessibility remediation runtime. */
(function () {
  'use strict';

  var focusableSelector = 'a[href], button, input, select, textarea, [tabindex]';

  function syncFlickityCard(card) {
    var hidden = card.getAttribute('aria-hidden') === 'true';
    card.querySelectorAll(focusableSelector).forEach(function (control) {
      if (hidden) {
        if (!control.hasAttribute('data-ffc-a11y-tabindex')) {
          control.setAttribute('data-ffc-a11y-tabindex', control.getAttribute('tabindex') || '');
        }
        control.setAttribute('tabindex', '-1');
      } else if (control.hasAttribute('data-ffc-a11y-tabindex')) {
        var previous = control.getAttribute('data-ffc-a11y-tabindex');
        if (previous === '') control.removeAttribute('tabindex');
        else control.setAttribute('tabindex', previous);
        control.removeAttribute('data-ffc-a11y-tabindex');
      }
    });
  }

  function syncFlickityCards(root) {
    var cards = [];
    if (root.nodeType === 1) {
      var owner = root.closest('.flickity-slider .grid-product[aria-hidden]');
      if (owner) cards.push(owner);
    }
    if (root.querySelectorAll) {
      cards = cards.concat(Array.from(root.querySelectorAll('.flickity-slider .grid-product[aria-hidden]')));
    }
    Array.from(new Set(cards)).forEach(syncFlickityCard);
  }

  function labelJudgeMeLinks(root) {
    var links = [];
    if (root.nodeType === 1 && root.matches('.jdgm-carousel-item__product')) links.push(root);
    if (root.querySelectorAll) {
      links = links.concat(Array.from(root.querySelectorAll('.jdgm-carousel-item__product')));
    }
    links.forEach(function (link) {
      if (link.getAttribute('aria-label')) return;
      var title = link.querySelector('.jdgm-carousel-item__product-title');
      var name = (title ? title.textContent : link.textContent).replace(/\s+/g, ' ').trim();
      if (name) link.setAttribute('aria-label', name);
    });
  }

  function fixScrollableTables(root) {
    var wrappers = [];
    if (root.nodeType === 1 && root.matches('.rte .table-wrapper')) wrappers.push(root);
    if (root.querySelectorAll) {
      wrappers = wrappers.concat(Array.from(root.querySelectorAll('.rte .table-wrapper')));
    }
    wrappers.forEach(function (wrapper) {
      if (!wrapper.hasAttribute('tabindex')) wrapper.setAttribute('tabindex', '0');
      if (!wrapper.hasAttribute('role')) wrapper.setAttribute('role', 'region');
      if (!wrapper.getAttribute('aria-label')) wrapper.setAttribute('aria-label', 'Scrollable data table');
    });
  }

  function titleCandyRackFrames(root) {
    var frames = [];
    if (root.nodeType === 1 && root.matches('iframe#candyrack-frame')) frames.push(root);
    if (root.querySelectorAll) {
      frames = frames.concat(Array.from(root.querySelectorAll('iframe#candyrack-frame')));
    }
    frames.forEach(function (frame) {
      if (!frame.getAttribute('title')) frame.setAttribute('title', 'Optional add-ons');
    });
  }

  function updateFloatingWidgets() {
    var cartOpen = document.body && document.body.id === 'candyrack-cart-body';
    document.querySelectorAll('shopify-chat, inbox-online-store-chat').forEach(function (widget) {
      if (cartOpen) {
        if (!widget.hasAttribute('data-ffc-a11y-visibility')) {
          widget.setAttribute('data-ffc-a11y-visibility', widget.style.getPropertyValue('visibility'));
          widget.setAttribute('data-ffc-a11y-visibility-priority', widget.style.getPropertyPriority('visibility'));
        }
        widget.style.setProperty('visibility', 'hidden', 'important');
      } else if (widget.hasAttribute('data-ffc-a11y-visibility')) {
        var previous = widget.getAttribute('data-ffc-a11y-visibility');
        var priority = widget.getAttribute('data-ffc-a11y-visibility-priority');
        if (previous) widget.style.setProperty('visibility', previous, priority);
        else widget.style.removeProperty('visibility');
        widget.removeAttribute('data-ffc-a11y-visibility');
        widget.removeAttribute('data-ffc-a11y-visibility-priority');
      }
    });
  }

  function repairLocksmithDeniedState() {
    var title = document.body && document.body.getAttribute('data-ffc-resource-title');
    var shopName = document.body && document.body.getAttribute('data-ffc-shop-name');
    var main = document.getElementById('MainContent');
    if (!title || !main) return;
    var signIn = main.querySelector('a[data-locksmith][href*="customer_authentication/login"]');
    if (!signIn) return;
    if (!document.title.trim()) document.title = title + ' – Sign in | ' + (shopName || 'Fish Finder Coach');
    if (!main.querySelector('h1')) {
      var heading = document.createElement('h1');
      heading.className = 'section-header__title ffc-locksmith-access-heading';
      heading.textContent = 'Course access required: ' + title;
      main.insertBefore(heading, main.firstChild);
    }
  }

  var dialogTitleCounter = 0;
  function labelAppEmbedDialogs(root) {
    var dialogs = [];
    if (root.nodeType === 1 && root.matches('#app-embed [role="dialog"], #app-embed [role="alertdialog"]')) {
      dialogs.push(root);
    }
    if (root.querySelectorAll) {
      dialogs = dialogs.concat(Array.from(root.querySelectorAll('#app-embed [role="dialog"], #app-embed [role="alertdialog"]')));
    }
    dialogs.forEach(function (dialog) {
      if (dialog.getAttribute('aria-label') || dialog.getAttribute('aria-labelledby')) return;
      var heading = dialog.querySelector('h1, h2, h3, [role="heading"]');
      if (heading && heading.textContent.trim()) {
        if (!heading.id) {
          dialogTitleCounter += 1;
          heading.id = 'ffc-app-dialog-title-' + dialogTitleCounter;
        }
        dialog.setAttribute('aria-labelledby', heading.id);
      } else {
        dialog.setAttribute('aria-label', 'Email signup');
      }
    });
  }

  function enhanceShopifyFormsRoot(root) {
    labelAppEmbedDialogs(root);
    root.querySelectorAll('#app-embed [role="dialog"] label, #app-embed [role="alertdialog"] label').forEach(function (label) {
      label.style.setProperty('color', '#4a4a4a', 'important');
    });
    root.querySelectorAll('#app-embed [role="dialog"] button[type="submit"], #app-embed [role="alertdialog"] button[type="submit"]').forEach(function (button) {
      button.style.setProperty('background-color', '#006b8f', 'important');
      button.style.setProperty('color', '#ffffff', 'important');
    });
  }

  function enhanceShopifyForms() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
      var root = embed.shadowRoot;
      if (!root) return;
      enhanceShopifyFormsRoot(root);
      if (!embed.hasAttribute('data-ffc-a11y-observed') && 'MutationObserver' in window) {
        embed.setAttribute('data-ffc-a11y-observed', 'true');
        new MutationObserver(function () { enhanceShopifyFormsRoot(root); }).observe(root, {
          childList: true,
          subtree: true
        });
      }
    });
  }

  function init() {
    syncFlickityCards(document);
    labelJudgeMeLinks(document);
    fixScrollableTables(document);
    titleCandyRackFrames(document);
    updateFloatingWidgets();
    repairLocksmithDeniedState();
    labelAppEmbedDialogs(document);
    enhanceShopifyForms();
    if (!('MutationObserver' in window) || !document.body) return;
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') {
          syncFlickityCards(record.target);
          if (record.attributeName === 'id') updateFloatingWidgets();
        }
        record.addedNodes.forEach(function (node) {
          syncFlickityCards(node);
          labelJudgeMeLinks(node);
          fixScrollableTables(node);
          titleCandyRackFrames(node);
          updateFloatingWidgets();
          repairLocksmithDeniedState();
          labelAppEmbedDialogs(node);
          enhanceShopifyForms();
        });
      });
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'id'],
      childList: true,
      subtree: true
    });
  }

  window.FFCAccessibility = window.FFCAccessibility || {};
  window.FFCAccessibility.syncFlickityCards = syncFlickityCards;
  window.FFCAccessibility.labelJudgeMeLinks = labelJudgeMeLinks;
  window.FFCAccessibility.fixScrollableTables = fixScrollableTables;
  window.FFCAccessibility.titleCandyRackFrames = titleCandyRackFrames;
  window.FFCAccessibility.updateFloatingWidgets = updateFloatingWidgets;
  window.FFCAccessibility.repairLocksmithDeniedState = repairLocksmithDeniedState;
  window.FFCAccessibility.labelAppEmbedDialogs = labelAppEmbedDialogs;
  window.FFCAccessibility.enhanceShopifyForms = enhanceShopifyForms;

  window.addEventListener('resize', function () { fixScrollableTables(document); });

  var shopifyFormsAttempts = 0;
  var shopifyFormsTimer = window.setInterval(function () {
    shopifyFormsAttempts += 1;
    enhanceShopifyForms();
    if (shopifyFormsAttempts >= 120) window.clearInterval(shopifyFormsTimer);
  }, 500);

  if ('MutationObserver' in window && document.head) {
    new MutationObserver(repairLocksmithDeniedState).observe(document.head, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
